const path = "./static/themes/pulp-fiction/audio/";
export const pulpFictionConfig = {
  intro: [
    `${path}Pulp_Fiction_Soundtrack_-_Son_of_a_Preacher_Man_1968_-_Dusty_Springfield_-_Track_7_-_HD.mp3`,
    `${path}Misirlou_Pulp_Fiction_Theme.mp3`,
  ],
};
